export class ContactMethod {
  id: number = null;
  name: string = null;
  description: string = null;
  message: string = null;
  contentTemplateId: string = null;
  checked: boolean = null;
}
